import {
  Rule,
  RuleOperator,
  RuleTypes,
  SlotLabel,
} from '@youshift/shared/types';
import { TFunction } from 'i18next';

import ShiftLabelLegend from '../../../../components/Calendars/ShiftLabelLegend';

export function ReqRuleNameDisplay({
  rule,
  slotLabels,
  t,
}: {
  rule: Rule;
  slotLabels: Record<number, SlotLabel>;
  t: TFunction;
}): JSX.Element {
  const { type, id_slot_labels, rule_operator, name } = rule;
  if (type !== RuleTypes.SLOT_LABEL_USER_REQS || !id_slot_labels) {
    return <span>{name}</span>;
  }
  const ruleOperator = rule_operator;
  if (ruleOperator === RuleOperator.AND) {
    return (
      <span className="flex items-center gap-1">
        <ShiftLabelLegend
          labels={id_slot_labels.map(
            id_slot_label => slotLabels[id_slot_label],
          )}
        />
        {id_slot_labels.length > 1 && (
          <span className="font-bold">{`(${t('manager.rulesConfig.all')})`}</span>
        )}
      </span>
    );
  }
  return (
    <span className="flex items-center gap-1">
      <ShiftLabelLegend
        labels={id_slot_labels.map(id_slot_label => slotLabels[id_slot_label])}
      />
      {id_slot_labels.length > 1 && (
        <span className="font-bold">{`(${t('manager.rulesConfig.any')})`}</span>
      )}
    </span>
  );
}
